import { ITaskProgramFormDTO, ITaskProgramFormViewDTO, ITaskProgramStoresViewDTO } from "../../coreapi-dto/dirs/taskProgram";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


class TaskProgramRequest extends BaseDirRequest<ITaskProgramFormViewDTO, ITaskProgramFormDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "TaskProgram", token, eventHandler)
    }

    viewStores(idGlobal: string, body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<ITaskProgramStoresViewDTO>>) => void, report?: (value) => void) {
            this.post<IViewWrapper<ITaskProgramStoresViewDTO>>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/View/Stores`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        this._eventHandler.onGetResponse(e);
                    } else {
                        callback?.(e);
                        report?.({ name: `${this._routePrefix}/${idGlobal}/View/Stores`, time: e.time })
                    }
                }
    
            })
        }
}

export default TaskProgramRequest